import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import { createUseStyles } from 'react-jss';

export interface DynamicFormModalProps {
  modalMaxWidth: string;
}

const styles: ComponentStylesProps<DynamicFormModalProps> = {
  modal: ({ modalMaxWidth }) => ({
    padding: '4rem 2.4rem',
    maxWidth: modalMaxWidth || '65.6rem',
    minHeight: '10rem',
    maxHeight: '75vh',
    // Section title. If it is empty it will no be rendered and styles will no be applied
    '& h2': {
      marginLeft: '-2rem',
      paddingLeft: '2rem',
    },
  }),
  title: {
    margin: '0',
    marginBottom: '2rem',
    font: { size: '2.4rem', lineHeight: '3.2rem', weight: 700 },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    padding: '0 1rem',
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    textAlign: 'center',
  },
  modalFooter: {
    marginTop: '6rem',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '0 13%',
    gap: '2rem',

    [breakpoints.sm.down]: {
      padding: 0,
    },
  },
  form: {
    position: 'relative',
  },
  disableForm: {
    paddingBottom: '1rem',
    cursor: 'not-allowed',
    margin: {
      top: '2rem',
      bottom: '4rem',
    },
    '&::after': {
      backgroundColor: 'rgba(242,244,248, 0.3)',
      position: 'absolute',
      content: "''",
      width: '100%',
      height: '100%',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 10,
      borderRadius: '1rem',
    },
  },
  // Padding left is needed for bc form, not for usual one
  section: { paddingLeft: 0 },
  button: {
    [breakpoints.sm.down]: {
      width: '100%',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
